<div class="onedbupload">
  <motif-modal-title class="upload-header">
    @if (isIPORModule) {
    <div class="uploadheader-container ipor-header-container">
      <i class="fa-solid fa-file-arrow-up custom-icon ipor-header-icon"></i>
      <div class="header-text ipor-header-text">
        <h2 class="header-title ipor-header-title">
          {{ "UploadmasterData" | translate }}
        </h2>
        <h4 class="sub-header-title ipor-sub-header-title">
          {{ "OneDataIPORSubtitle" | translate }}
        </h4>
      </div>
    </div>
    } @else {
    <div class="uploadheader-container default-header-container">
      <i class="fa-solid fa-file-arrow-up custom-icon default-header-icon"></i>
      <div class="header-text default-header-text">
        <h2 class="header-title default-header-title">
          {{ "UploadmasterData" | translate }}
        </h2>
        <h4 class="sub-header-title default-sub-header-title">
          {{ "OneDataUploadSubHeadingMessage" | translate }}
        </h4>
      </div>
    </div>
    }
    <button motifIconButton aria-label="Close modal" [motif-modal-close]="true" [size]="buttonSizes.LARGE"
      class="close-button">
      <motif-icon class="motif-modal-header-close-icon" [ngClass]="{'close-icon': isIPORModule}"
        [iconFunction]="closeIcon"></motif-icon>
    </button>
  </motif-modal-title>
  <motif-modal-content>
    <div class="upload-container">
      <div class="upload-section">
        <fieldset class="uploader" motif-file-uploader-container>
          <input motif-file-uploader aria-label="File uploader" accept=".xls,.xlsx" [disabled]="false" multiple
            (onDrop)="onDrop($event)" (valueChange)="onValueChange($event)" />
        </fieldset>
        @if (fileLoaded && files.length === 1) {
        <motif-uploader variation="grey" fileName="{{ fileName }}" fileSize="{{ fileSize }}" [progressValue]="100"
          progressLabel="20 of 200 KB" role="button" tabindex="0" (click)="removeFile($event)"
          (keydown)="onUploaderKeydown($event)" [determinated]="true" [showIcon]="true" [disabled]="false"
          [completed]="true">
        </motif-uploader>
        } @else if (fileLoaded && files.length > 1) {
        @for (file of files; track file) {
        <motif-uploader variation="grey" fileName="{{ file.name }}" fileSize="{{ file.size }}" [progressValue]="100"
          progressLabel="20 of 200 KB" role="button" tabindex="0" (click)="removeFile($event)"
          (keydown)="onUploaderKeydown($event)" [determinated]="true" [showIcon]="true" [disabled]="false"
          [completed]="true">
        </motif-uploader>
        }
        }
      </div>
    </div>
  </motif-modal-content>
  <div class="info-div">
    <span>{{ "SupportedFormats" | translate }} {{ allowedExtensions.join(", ") }}
    </span>
    <span>{{ "MaxFileSize" | translate }} {{ maxFileSize }}MB </span>
  </div>
  <hr class="break-line" />
  <div></div>
  <motif-modal-actions class="upload-footer">
    <div class="download-button">
      @if (isIPORModule) {
        <button motifButton color="primary" (click)="downloadTemplate()" [attr.aria-label]="'DownloadTemplate' | translate">
          {{ "DownloadTemplate" | translate }}
        </button>
      }
    </div>
    <div class="checkbox-container">
      <motif-form-field>
        <motif-checkbox [(ngModel)]="fullReplacement">
          <span class="checkboxlabel"> {{ "FullReplacement" | translate }} </span>
        </motif-checkbox>
      </motif-form-field>
      <button motifButton color="primary" [disabled]="files.length == 0" (click)="proceed()" [attr.aria-label]="'Proceed' | translate">
        {{ "Proceed" | translate }}
      </button>
      <button motifButton color="secondary" [motif-modal-close]="true" aria-label="ok">
        {{ "Cancel" | translate }}
      </button>
    </div>
  </motif-modal-actions>
</div>